export default {"src":"/_next/static/media/dark-mode-icon-uncollapsed.9e47f84d.svg","height":186,"width":1285,"blurWidth":0,"blurHeight":0};